module.exports = __webpack_public_path__ + "videos/video-2016.3004917.webm";